import { callFunction } from '../utils/apiClient';
import { handleServiceError } from '../utils/ServiceError';

export interface WorkspaceBranding {
  workspace_name: string;
  workspace_slug: string | null;
  workspace_logo_url: string | null;
  workspace_primary_color: string;
  workspace_accent_color: string | null;
  workspace_font_family: string;
  theme_dark_bg: string;
  theme_dark_heading: string;
  theme_light_bg: string;
  theme_light_heading: string;
}

export interface WorkspaceBySlug {
  id: string;
  name: string;
  workspace_name: string;
  workspace_slug: string;
  workspace_logo_url: string | null;
  workspace_primary_color: string;
  workspace_accent_color: string | null;
  workspace_font_family: string;
  theme_dark_bg: string;
  theme_dark_heading: string;
  theme_light_bg: string;
  theme_light_heading: string;
}

/**
 * Get workspace branding for current user
 */
export const getWorkspaceBranding = async (): Promise<WorkspaceBranding> => {
  try {
    const data = await callFunction<{ success: boolean; branding: WorkspaceBranding }>('getWorkspaceBranding', {});

    if (!data.success) {
      throw new Error('Failed to get workspace branding');
    }

    return data.branding;
  } catch (error) {
    throw handleServiceError(error, 'getWorkspaceBranding');
  }
};

/**
 * Get workspace by slug (for /org/:slug routing)
 */
export const getWorkspaceBySlug = async (slug: string): Promise<WorkspaceBySlug> => {
  try {
    const data = await callFunction<{ success: boolean; workspace: WorkspaceBySlug }>('getWorkspaceBySlug', { slug }, { requireAuth: false });

    if (!data.success) {
      throw new Error('Workspace not found');
    }

    return data.workspace;
  } catch (error) {
    throw handleServiceError(error, 'getWorkspaceBySlug');
  }
};
